import React from "react";
import { ArrowUpRight, Check } from "lucide-react";
import { SERVICES } from "../data/site";
import { Reveal, SectionHeading } from "./Reveal";

export const Services = () => {
  const go = () => document.getElementById("quote")?.scrollIntoView({ behavior: "smooth" });
  return (
    <section id="services" className="mx-auto max-w-7xl px-5 md:px-8 py-24 md:py-32">
      <Reveal>
        <SectionHeading
          overline="What We Do"
          title="Signage Built for the Job"
          sub="From a single trailer to a full commercial fleet and everything on the building — we cover it end to end."
        />
      </Reveal>

      <div className="mt-14 grid md:grid-cols-2 gap-5">
        {SERVICES.map((s, i) => (
          <Reveal key={s.key} delay={i * 0.08}>
            <div
              data-testid={`service-card-${s.key}`}
              className="group relative h-full border border-line bg-ink-800 overflow-hidden hover:-translate-y-1 hover:border-orange/50 transition-all duration-300"
            >
              <div className="relative h-52 overflow-hidden">
                <img
                  src={s.image}
                  alt={s.title}
                  loading="lazy"
                  className="h-full w-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-ink-800 via-ink-800/30 to-transparent" />
              </div>
              <div className="p-7">
                <div className="flex items-start justify-between gap-4">
                  <h3 className="font-head font-extrabold uppercase text-xl tracking-tight">{s.title}</h3>
                  <ArrowUpRight className="text-orange shrink-0 opacity-0 group-hover:opacity-100 -translate-x-2 group-hover:translate-x-0 transition-all" />
                </div>
                <p className="mt-2 text-white/55 text-sm leading-relaxed">{s.blurb}</p>
                <ul className="mt-5 grid grid-cols-2 gap-y-2 gap-x-3">
                  {s.items.map((it) => (
                    <li key={it} className="flex items-center gap-2 text-sm text-white/75">
                      <Check size={14} className="text-orange shrink-0" /> {it}
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </Reveal>
        ))}
      </div>

      <Reveal delay={0.1}>
        <div className="mt-5 border border-line bg-ink-800 p-8 md:p-10 flex flex-col md:flex-row md:items-center justify-between gap-6">
          <div>
            <span className="overline">Design & Installation</span>
            <h3 className="mt-2 font-head font-extrabold uppercase text-2xl tracking-tight">
              From concept through installation
            </h3>
            <p className="mt-2 text-white/55 max-w-xl">
              High-quality materials and expert workmanship, managed for you from the first
              mockup to the final panel on site.
            </p>
          </div>
          <button
            data-testid="services-quote-btn"
            onClick={go}
            className="shrink-0 bg-orange hover:bg-orange-hover text-white font-head font-bold uppercase tracking-wide px-8 py-4 transition-colors"
          >
            Start Your Project
          </button>
        </div>
      </Reveal>
    </section>
  );
};
